import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const APARTMENT_SUITE_MAX_LENGTH = 40;

export const APARTMENT_SUITE_SCHEMA_FIELD_NAME = "aptSuite";

export const getApartmentSuiteFormFieldSchema = (label = i18n("ApartmentSuiteFormField__LABEL")) =>
  yup
    .string()
    .trim()
    .alphaNumericHyphenPeriodSpace()
    .max(APARTMENT_SUITE_MAX_LENGTH)
    .label(label.toLowerCase());
